import { useLenis } from "lenis/react";

export default function Footer({ brand, footer, contact }) {
  const year = new Date().getFullYear();
  const lenis = useLenis();
  const name = brand?.name || "LIEBER SOURCING";
  const [nameFirst, ...nameRest] = name.split(" ");
  const go = (e, id) => {
    e.preventDefault();
    if (lenis) lenis.scrollTo(`#${id}`, { offset: -80 });
    else document.querySelector(`#${id}`)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-navy text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 py-14 md:py-20">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <div className="flex items-center gap-4">
              {brand?.logoUrl && <img src={brand.logoUrl} alt="Lieber Sourcing" className="h-16 w-auto bg-white rounded-lg p-2" />}
              <div>
                <div className="font-display font-extrabold text-2xl md:text-3xl text-white tracking-tight leading-none">
                  {nameFirst} {nameRest.length > 0 && <span className="text-barn">{nameRest.join(" ")}</span>}
                </div>
                <div className="font-body text-xs text-white/60 tracking-wide mt-1.5">{brand?.tagline}</div>
              </div>
            </div>
            <p className="mt-6 font-body text-white/60 max-w-md leading-relaxed">{footer?.blurb}</p>
          </div>
          <div className="md:col-span-3">
            <div className="overline text-barn mb-4">Contact</div>
            <div className="space-y-2 font-body text-white/70 text-sm">
              <a href={`mailto:${contact?.email}`} className="block hover:text-white transition-colors">{contact?.email}</a>
              <a href={`tel:${contact?.phone}`} className="block hover:text-white transition-colors">{contact?.phone}</a>
              <div>{contact?.address}</div>
            </div>
          </div>
          <div className="md:col-span-3">
            <div className="overline text-barn mb-4">Navigate</div>
            <div className="space-y-2 font-body text-white/70 text-sm">
              {[["about", "The Edge"], ["services", "Capabilities"], ["manifesto", "Why Now"], ["contact", "Contact"]].map(([id, label]) => (
                <a key={id} href={`#${id}`} onClick={(e) => go(e, id)} className="block hover:text-white transition-colors">{label}</a>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3">
          <span className="font-body text-xs text-white/50">© {year} {footer?.copyright}</span>
          <span className="font-body text-xs text-white/50 tracking-wide">Fort Worth, TX · Sourcing Worldwide</span>
        </div>
      </div>
    </footer>
  );
}
